import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Check, Award } from 'lucide-react';
const programs = [{
  title: "Lil' Warriors",
  age: 'Ages 4-5',
  description: 'Our Lil Warriors program is focused on building foundation and discipline. These skills will help with focus, balance, and motor skills. Through fun engaging activities our youngest martial artists develop essential coordination and listening skills in a positive supportive environment.',
  benefits: ['Foundation Building', 'Focus & Discipline', 'Balance & Coordination', 'Motor Skills Development'],
  image: 'https://cdn.magicpatterns.com/uploads/dNRDMUjXdKNw3ztfmZFiYU/image.png',
  showTrial: true
}, {
  title: 'Youth & Adult Classes',
  age: 'Ages 6+',
  description: 'Our most popular class! We make it easy for the whole family! Parents and kids are welcomed to join each other on the mats to work on their blocks, kicks, self defense, and physical exercise! Train together, grow together, and build lasting family bonds through martial arts.',
  benefits: ['Family Training Together', 'Blocks & Kicks', 'Self-Defense Skills', 'Physical Exercise'],
  image: 'https://cdn.magicpatterns.com/uploads/eVfgbvi8r9gahN4jWY3v2C/Youth_and_Adult.png',
  showTrial: true
}, {
  title: 'Competition Team',
  age: 'Ages 6+',
  description: 'For our hardest working athletes that want to explore the sport of taekwondo. Spar at tournaments, go to seminars and join our sparring team family. This elite program is designed for dedicated students ready to take their training to the competitive level.',
  benefits: ['Tournament Competition', 'Exclusive Seminars', 'Elite Sparring Training', 'Team Family Culture'],
  image: 'https://cdn.magicpatterns.com/uploads/9hN2ruYtXeWcnYkER2EJps/Competition_Team.png',
  showTrial: false
}];
export function ProgramsPage() {
  return <main className="pt-40 pb-20 bg-gray-50" data-id="element-518">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-519">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-520">
          <Award className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-521" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-522">Our Programs</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-523">
            Expert instruction for every age and skill level. Find the perfect
            class for you or your child.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-524">
        {programs.map((program, index) => <Card key={program.title} className="overflow-hidden" data-id="element-525">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-526">
              <div className={`h-64 md:h-auto overflow-hidden ${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-527">
                <img src={program.image} alt={program.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-528" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-529">
                <div className="flex items-center mb-4" data-id="element-530">
                  <h2 className="text-3xl font-bold text-gray-900 mr-4" data-id="element-531">
                    {program.title}
                  </h2>
                  <span className="bg-blue-100 text-primary px-3 py-1 rounded-full text-sm font-semibold" data-id="element-532">
                    {program.age}
                  </span>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-533">
                  {program.description}
                </p>

                <div className="mb-8" data-id="element-534">
                  <h3 className="font-semibold text-gray-900 mb-3" data-id="element-535">
                    Program Benefits:
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-536">
                    {program.benefits.map(benefit => <div key={benefit} className="flex items-center text-gray-600 text-sm" data-id="element-537">
                        <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-538" />
                        {benefit}
                      </div>)}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 mt-auto" data-id="element-539">
                  {program.showTrial && <Link to="/trial" data-id="element-540">
                      <Button data-id="element-541">Start 4-Week Trial</Button>
                    </Link>}
                  <Link to="/contact" data-id="element-542">
                    <Button variant="outline" data-id="element-543">Contact Us</Button>
                  </Link>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </main>;
}